import styled from 'styled-components';

export default styled.div`
  position: fixed;
  bottom: 200px;
  right: 5px;
  background-color: rgb(54, 61, 74);
  border-radius: 2px;
`;
